import type Device from "@/models/device";

/**
 *
 * @param {Object} device Device from API
 * @param {Object} opts { newActivateBox: boolean }
 * @returns string
 */
export const landingRoute = (device: Device, opts = {}) => {
	const { newActivatedBox = false } = opts;

	if (!device) {
		return "box-v1-settings";
	}

	// if device is a cloud-hub to redirect to hub view
	if (device.type === "BRIDGE" || device.type === "CLASSICAL_HUB") {
		// should add permissions check, but at this level it would require a lot of calls & computation
		return "hub-v1-settings";
	}

	// if it's a brand new activated box, redirect to configuration
	if (newActivatedBox) {
		return "box-v1-settings";
	}

	// if any unresolved alarm, redirect user to alarms list
	if (device.hasOpenAlarms) {
		return "box-v1-alarms-list-history";
	}

	// if it's a tower lift, redirect to live data page
	if (device.isTowerLift) return "box-v1-live-data";

	return "box-v1-dashboard"; // default route
};

/**
 *
 * @param {Object} device Device from API
 * @returns string
 */
export const liveDataRoute = (device: Device) => {
	if (!device) {
		return "box-v1-live-data";
	}

	// if device is a cloud-hub to redirect to hub view
	if (device.type === "BRIDGE" || device.type === "CLASSICAL_HUB") {
		return "hub-v1-live-data";
	}
	return "box-v1-live-data";
};

export const listRoute = (deviceType: string) => {
	if (deviceType === "BRIDGE") {
		return "hubs";
	}

	return "boxes";
};
